import React, { Fragment } from "react";

import { Box, A, Text } from "src/components";

const Address = ({
  address: { line1, line2, city, state, zip },
  directionsUrl,
  color,
  linkColor = "green",
}) => (
  <Box>
    <Text fontSize={2} color={color}>
      {line1}
      <br />
      {line2 && (
        <Fragment>
          {line2}
          <br />
        </Fragment>
      )}
      {city}, {state}, {zip}
    </Text>
    <A href={directionsUrl} target="_blank" fontSize={2} color={linkColor}>
      Directions
    </A>
  </Box>
);

export default Address;



// WEBPACK FOOTER //
// ./src/locator/LocationAddress.js